"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripTrailingSlash = void 0;
var stripTrailingSlash = function stripTrailingSlash(str) {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};
exports.stripTrailingSlash = stripTrailingSlash;